// @ts-nocheck
import { useLocalStorage } from 'platform-components/src/utils/hooks/useLocalStorage';
import qs from 'query-string';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router';

import { getCurrentTeamLevel } from 'common.components/user/selectors';

export function useCurrentTeamGrade() {
    const params = useParams<Record<string, string>>();
    const currentTeamId = params.classId;
    return useSelector((s) => getCurrentTeamLevel(s, { classId: currentTeamId }));
}

export function useGradeFromQueryOrTeam(defaultValue: number) {
    const { search } = useLocation();
    const query = qs.parse(search);

    const gradeFromQuery = +query.grade || undefined;
    const gradeFromTeam = useCurrentTeamGrade();

    return gradeFromQuery || gradeFromTeam || defaultValue;
}

export function useCurrentGrade(defaultValue?: number, doNothing?: boolean) {
    const params = useParams<Record<string, string>>();
    const { pathname, search } = useLocation();
    const localStorage = useLocalStorage();
    const history = useHistory();
    const query = qs.parse(search);
    const queryGrade = +query.grade;
    const currentTeamId = params.classId;
    const teamGrade = useCurrentTeamGrade();

    useEffect(() => {
        if (currentTeamId || doNothing) {
            return;
        }

        if (!queryGrade) {
            const savedGrade = +localStorage.get('grade');
            const newQuery = qs.stringify({ ...query, grade: savedGrade || defaultValue });
            history.replace(`${pathname}${pathname.includes('?') ? '&' : '?'}${newQuery}`);
        } else {
            localStorage.set('grade', queryGrade);
        }
    }, [doNothing, currentTeamId, defaultValue, history, localStorage, pathname, query, queryGrade]);

    return teamGrade || queryGrade || null;
}
